import React from "react";

import { getFullName } from "helpers";
import { isInactiveAgentStatus } from "mappers";

export const UserOptionLabel = option => {
	const userName = getFullName(option);
	const inactive =
		isInactiveAgentStatus(option?.status) ||
		isInactiveAgentStatus(option?.statusType)
			? "(Inactive)"
			: "";

	if (inactive) {
		return (
			<i>
				{userName} {inactive}
			</i>
		);
	} else {
		return userName;
	}
};

export const UserOptionLabelByPartnerStatus = (
	option,
	status = "statusType",
) => {
	const userName = getFullName(option);
	// 1 - Terminated; 4 - Inactive
	const inactive =
		option[status] === 1 || option[status] === 4 ? "(Inactive)" : "";

	if (inactive) {
		return <i>{`${userName} ${inactive}`}</i>;
	} else {
		return userName;
	}
};

export const CompanyOptionLabelByStatus = option => {
	// 1 - Terminated; 4 - Inactive
	const inactive =
		option?.status?.value === 1 || option?.status?.value === 4
			? "(Inactive)"
			: "";

	if (inactive) {
		return <i>{`${option?.name} ${inactive}`}</i>;
	} else {
		return option && `${option?.name}`;
	}
};

export const MerchantOptionLabel = option => (
	<>
		<small>{option.dbaName}</small>
		&nbsp;
		<small
			style={{
				fontWeight: "bold",
				color: "#cfcfcf",
			}}
		>
			({option.mid})
		</small>
	</>
);

export const AgentOfficeOptionLabel = option => {
	if (option?.is_active || option?.active) {
		return option?.name;
	} else {
		return <i>{option?.name} (Inactive)</i>;
	}
};

export const industryTypeMCC = option => `${option.label}`;
